/**
 * Badge component
 * @returns <Badge />
 */

// This is to use dummy data
import { mock } from "../mock/data";
const { imageSrc } = mock;

const Badge = ({ text, backgroundColor, type }) => {
  const { iconSources } = mock;

  if (type === "badge-card") {
    return (
      <div className="badge-card" style={{ backgroundColor: backgroundColor ? backgroundColor : "" }}>
        <p>{text}</p>
      </div>
    )
  }

  if (type === "badge-detail") {
    return (
      <div className="badge-detail" style={{ backgroundColor: backgroundColor ? backgroundColor : "" }}>
        <p>{text}</p>
      </div>
    )
  }

  if (type === "maintenance") {
    return (
      <div className="badge" style={{ backgroundColor: backgroundColor ? backgroundColor : "" }}>
        <img src={iconSources[type]} alt="" />

        <p>{text}</p>
      </div>
    )
  }
}

export default Badge